'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var StyledAsterisk = styled__default.span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  padding-left: 4px;\n"], ["\n  color: ", ";\n  padding-left: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var Asterisk = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, children = _a.children, restProps = tslib_es6.__rest(_a, ["dataCy", "dataTestId", "children"]);
    return (React__default.createElement("span", { "data-cy": dataCy && dataCy + "-asterisk", "data-testid": dataTestId && dataTestId + "-asterisk" },
        children,
        React__default.createElement(StyledAsterisk, tslib_es6.__assign({}, restProps), "*")));
};
var templateObject_1;

exports.Asterisk = Asterisk;
